import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useStyles } from "Styles";
import Badge from "@mui/material/Badge";
import { Link, useHistory, Link as DomLink } from "react-router-dom";
import { NavLink } from "reactstrap";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as React from "react";
import TimeOutDialog from "components/common/TimeoutDialog";
import headerIcon from "../../../images/headerIcon.png";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeIcon from "../../../images/home.svg";
import { useDirtyCheck } from "hooks/DirtyCheckProvider";
import useSysParam from "hooks/UseSysParam";
import useNavFixed from "hooks/useNavFixed";
import AccessQrCode from "components/accessQrCode";
import Popover from "@mui/material/Popover";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import PushPinIcon from "../../../images/PushPinIcon.svg";
import PushPinIconActiveIcon from "../../../images/PushPinIconActive.svg";
import { HomeLayoutViewContext } from "components/HomeLayout";
import format from "date-fns/format";
import { DATE_FORMAT_YMD_DISPLAY } from "constant";
import NotSignOut from "components/accessQrCode/NotSignOut";
import "./HomeLayout.css";

function HomeLayoutPC(props) {
	const {
		classes,
		user,
		timeoutOpen,
		emails,
		addresses,
		usefulLinks,
		sitemaps,
		logoLink,
		contactEmail,
		location,
		openQrCode,
		navRef,
		isFixed,
		notificationAnchorEl,
		setOpenQrCode,
		setNotificationAnchorEl,
		getUserEmail,
		promptLogout,
		onSessionExtend,
		closeSessionExtend,
		closeTimeout,
		doLogout,
		getExpTime,
		lastLoginTime,
		goTop,
		clickMenu,
		clickNotification,
		notifications,
		handlePinned,
		notificationRedirect,
		handleDeleteNotification,
		showNtfRedirect,
		showNtfClose,
		loadNotifications,
	} = React.useContext(HomeLayoutViewContext);

	const HOMEPAGE = user?.homePage ?? "/homepage";

	const renderNotificationItem = (ntf) => {
		return (
			<Grid
				container
				style={{
					padding: "10px",
					borderBottom: "1px solid #dcdcdc",
					fontSize: 13,
					position: "relative",
					background: ntf.isRead ? "unset" : "#DEECF3",
				}}
				alignItems="start"
			>
				<Grid
					container
					item
					style={{ flex: 1, color: ntf.isRed ? "red" : "unset" }}
					dangerouslySetInnerHTML={{ __html: ntf.title }}
				></Grid>
				<Grid container item style={{ width: 66 }} justifyContent={"flex-end"}>
					<IconButton
						aria-label="PushPinIcon"
						style={{ padding: 2, height: 22, width: 22 }}
						onClick={() => handlePinned(ntf)}
						size="large"
					>
						<img style={{ width: 18 }} src={ntf.isPinned ? PushPinIconActiveIcon : PushPinIcon} />
					</IconButton>
					{showNtfRedirect(ntf) && (
						<IconButton
							aria-label="KeyboardArrowRightIcon"
							style={{ padding: 2, height: 22, width: 22 }}
							onClick={() => notificationRedirect(ntf)}
							size="large"
						>
							<KeyboardArrowRightIcon style={{ fontSize: 20, color: "#f58220" }} size="small" />
						</IconButton>
					)}
					{showNtfClose(ntf) && (
						<IconButton
							aria-label="close"
							style={{ padding: 2, height: 22, width: 22 }}
							size="large"
							onClick={() => handleDeleteNotification(ntf)}
						>
							<CloseIcon style={{ fontSize: 20, color: "#000" }} size="small" />
						</IconButton>
					)}
				</Grid>
				<Grid container style={{ color: "#9a9a9a" }}>
					{format(new Date(ntf.ntfDate), DATE_FORMAT_YMD_DISPLAY)}
				</Grid>
			</Grid>
		);
	};

	return (
		<div style={{ height: "100vh", width: "100%", fontFamily: "Quicksand-SemiBold", minWidth: 1000 }}>
			<CssBaseline />
			{/* top menu */}
			<Grid
				container
				direction="column"
				flexWrap={"nowrap"}
				className={classes.fixedTop}
			>
				<Grid container ref={navRef}>
					<Grid item container>
						<Grid
							container
							justifyContent="space-between"
							style={{ padding: "5px", backgroundColor: "#fff" }}
							alignItems="center"
						>
							<Grid item>
								<a href={logoLink} target={"_blank"} className="headerIconLink">
									<img className="headerIcon" src={headerIcon} />
								</a>
							</Grid>
							<Grid item>
								<Grid container alignItems="center">
									<Grid item>
										<Grid container direction="column" style={{ fontSize: "13px" }}>
											<Grid item container alignItems="center" justifyContent="flex-end">
												<Grid item style={{ fontWeight: "bold" }}>
													{getUserEmail()}
												</Grid>
												<Grid
													item
													className={classes.logoutButton}
													onClick={() => {
														doLogout();
													}}
												>
													Logout
												</Grid>
											</Grid>
											<Grid item>{lastLoginTime(sessionStorage.getItem("lastLoginTime"))}</Grid>
										</Grid>
									</Grid>
									<Grid item>
										<IconButton
											className={classes.bellButton}
											onClick={clickNotification}
											size="large"
										>
											{/* badgeContent={3} */}
											<Badge color="secondary" badgeContent={notifications.length}>
												<Avatar sx={{ bgcolor: "#15A9D2", width: 30, height: 30 }}>
													<NotificationsIcon sx={{ color: "white" }} fontSize="medium" />
												</Avatar>
											</Badge>
										</IconButton>
										{notificationAnchorEl && (
											<Popover
												id={"notification-popover"}
												open={true}
												anchorEl={notificationAnchorEl}
												onClose={() => {
													setNotificationAnchorEl(null);
													loadNotifications();
												}}
												anchorOrigin={{
													vertical: "bottom",
													horizontal: "center",
												}}
											>
												<Grid container style={{ width: 365 }}>
													<Grid
														container
														style={{
															padding: "10px",
															backgroundColor: "#ffefe1",
															height: 40,
															position: "fixed",
															zIndex: 1,
															width: 365,
														}}
													>
														<Grid item style={{ fontSize: 13, color: "#f58220" }}>
															Notification
														</Grid>
														<IconButton
															aria-label="close"
															style={{
																position: "absolute",
																top: 5,
																right: 5,
																padding: 5,
															}}
															onClick={() => {
																setNotificationAnchorEl(null);
															}}
															size="large"
														>
															<CloseIcon
																style={{ fontSize: 20, color: "#000" }}
																size="small"
															/>
														</IconButton>
													</Grid>
													<Grid container style={{ color: "#000", marginTop: 40 }}>
														{notifications?.map((ntf) => {
															return renderNotificationItem(ntf);
														})}
														{/* <Grid container style={{ padding: '10px', borderBottom: '1px solid #dcdcdc', fontSize: 13 }} alignItems='center'>
                                                        <Grid container item style={{ flex: 1 }}>Urgent Close at 13:00 on 11 Mar 2022</Grid>
                                                        <Grid container item style={{ width: 44 }}>
                                                            <IconButton aria-label="PushPinIcon" style={{ padding: 2, height: 22, width: 22 }} >
                                                                <img style={{ width: 18 }} src={PushPinIcon} />
                                                            </IconButton>
                                                            <IconButton aria-label="KeyboardArrowRightIcon" style={{ padding: 2, height: 22, width: 22 }} >
                                                                <KeyboardArrowRightIcon style={{ fontSize: 20, color: '#f58220' }} size='small' />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid container style={{ color: '#9a9a9a' }}>31 Mar 2022</Grid>
                                                    </Grid>
                                                    <Grid container style={{ padding: '10px', borderBottom: '1px solid #dcdcdc', fontSize: 13 }} alignItems='center'>
                                                        <Grid container item style={{ flex: 1 }}>Below researcher has not signed-out:</Grid>
                                                        <Grid container item style={{ width: 44 }}>
                                                            <IconButton aria-label="PushPinIcon" style={{ padding: 2, height: 22, width: 22 }} >
                                                                <img style={{ width: 18 }} src={PushPinIconActiveIcon} />
                                                            </IconButton>
                                                            <IconButton aria-label="KeyboardArrowRightIcon" style={{ padding: 2, height: 22, width: 22 }} >
                                                                <KeyboardArrowRightIcon style={{ fontSize: 20, color: '#f58220' }} size='small' />
                                                            </IconButton>
                                                        </Grid>
                                                        <Grid container >Axxxx WONG T** M**</Grid>
                                                        <Grid container >[1 Apr 2022]</Grid>
                                                        <Grid container style={{ color: '#9a9a9a' }}>31 Mar 2022</Grid>
                                                    </Grid> */}
													</Grid>
												</Grid>
											</Popover>
										)}
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid item container className={classes.topMenu}>
						<Grid item xs={"auto"} style={{ width: "60px", height: "40px" }}>
							<NavLink
								onClick={goTop}
								tag={Link}
								className="text-white"
								to={HOMEPAGE}
								active={location.pathname === HOMEPAGE}
								style={{ padding: "auto" }}
							>
								<img src={HomeIcon} />
							</NavLink>
						</Grid>
						<Divider orientation="vertical" flexItem />
						{user?.menus?.topMenus?.map((item) => {
							return (
								<React.Fragment key={item.code}>
									<Grid item xs>
										{item.code === "TM_CONTACT_US" ? (
											<NavLink
												onClick={goTop}
												className="text-white"
												active={location.pathname === item.path}
											>
												{" "}
												<a
													className="text-white"
													style={{ textDecoration: "none" }}
													href={`mailto:${contactEmail || ""}`}
												>
													{item.title}
												</a>
											</NavLink>
										) : (
											<NavLink
												onClick={() => clickMenu(item.code)}
												tag={Link}
												className="text-white"
												to={item.path}
												active={location.pathname === item.path}
											>
												{item.title}
											</NavLink>
										)}
									</Grid>
									<Divider orientation="vertical" flexItem />
								</React.Fragment>
							);
						})}
					</Grid>
				</Grid>
			</Grid>
			<div style={{ margin: "0px", width: "100%" }} className={classes.bodyContent}>
				{props.children}
			</div>
			<Grid container direction="column" style={{ backgroundColor: "#333" }}>
				<Grid item xs="auto" container className={classes.bottomBox}>
					<Grid item container>
						<Grid item xs={4} container>
							<List>
								{/* <ListItem>
                                    <NavLink tag={DomLink} className="text-white" to={'#'}>HADCL WEBSITE</NavLink>
                                </ListItem> */}
								<ListItem>Contact Us</ListItem>
								<ListItem>
									<span style={{ lineHeight: "initial" }}>For EHPDCL Portal related enquiries,</span>
								</ListItem>
								<ListItem>
									<EmailIcon className={classes.emailIcon} />
									&nbsp; please contact &nbsp;
									<a
										style={{ textDecoration: "underline" }}
										href={`mailto:${emails.length && emails[0].content}`}
									>
										{emails.length && emails[0].content}
									</a>
								</ListItem>
								{contactEmail && (
									<>
										<ListItem>
											<span style={{ lineHeight: "initial" }}>For other enquiries,</span>
										</ListItem>
										<ListItem>
											<EmailIcon className={classes.emailIcon} />
											&nbsp; please contact &nbsp;
											<a style={{ textDecoration: "underline" }} href={`mailto:${contactEmail}`}>
												{contactEmail}
											</a>
										</ListItem>
									</>
								)}

								<ListItem>
									<LocationOnIcon className={classes.emailIcon} />
									&nbsp;
									<span style={{ lineHeight: "initial" }}>
										{addresses.length && addresses[0].content}
									</span>
								</ListItem>
							</List>
						</Grid>
						<Grid item xs={4}>
							<List>
								<ListItem>FUNCTIONS</ListItem>
								{sitemaps.map((sm) => {
									return (
										<ListItem key={sm.code}>
											<ArrowForwardIosIcon style={{ fontSize: "12px" }} />
											&nbsp;
											<NavLink
												onClick={() => {
													clickMenu(sm.code);
												}}
												tag={DomLink}
												className="text-white"
												to={sm.path}
											>
												{sm.title}
											</NavLink>
										</ListItem>
									);
								})}
							</List>
						</Grid>
						<Grid item container xs={4}>
							<List>
								<ListItem>USEFUL LINKS</ListItem>
								{usefulLinks.map((ul) => {
									return (
										<ListItem key={ul.id}>
											<ArrowForwardIosIcon style={{ fontSize: "12px" }} />
											&nbsp;
											<a style={{ textDecoration: "underline" }} href={ul.href} target="_blank">
												{ul.title}
											</a>
										</ListItem>
									);
								})}
							</List>
						</Grid>
					</Grid>
				</Grid>
				<Grid item container className={classes.bottomCopyright} >
					<Grid item>Copyright © {new Date().getFullYear()} Hospital Authority. All rights reserved.</Grid>
				</Grid>
			</Grid>
			{/* </main> */}
			<TimeOutDialog open={timeoutOpen} onClose={closeTimeout} />
			{openQrCode && (
				<AccessQrCode
					onClose={() => {
						setOpenQrCode(false);
					}}
				/>
			)}
			{/* <NotSignOut /> */}
		</div>
	);
}

export default HomeLayoutPC;
